const s = {
  name: "Ratio9x16",
  dimensions: { width: 22, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22 40" style="enable-background:new 0 0 22 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6,34v-4H4v6h6v-2H6z"/>
		<path class="st0" d="M12,6h4v4h2V4h-6V6z"/>
		<path class="st0" d="M22,0v40H0V0H22z M20,2H2v36h18V2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Ratio9x16
};
